import React, { useEffect } from 'react';
import styled from 'App/styled';
import { MicroPhoneProps } from 'types/voiceSearch';
import MicroIcon from '../Icons/Microphone';
import { noop } from '../../constants';
import useMicrophone from 'hooks/voiceSearch';
import { trackVoiceSearchSupport } from 'helpers/voiceSearch';


const Wrapper = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  position: absolute;
  right: 30px;
  width: 10px;
`;

const MicroPhone = ({ handleMicrophone = noop, customClass = '' }: MicroPhoneProps) => {
  const { support } = useMicrophone();

  useEffect(() => {
    trackVoiceSearchSupport(support);
  }, [support]);

  if (!support) {
    return null;
  }

  return (
    <Wrapper className={customClass} onClick={handleMicrophone}>
      <MicroIcon />
    </Wrapper>
  );
};

export default MicroPhone;
